export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const uid = () => typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

// ---------- VALUE INFLECTION ----------
export const WHO_CARES_OPTIONS = [
  "Seed investor", "Series A investor", "Pharma Search & Evaluation", "Pharma BD",
  "Pharma translational team", "Grant funder", "Disease foundation", "Strategic partner",
  "Acquirer", "Other",
];
export const MILESTONE_CATEGORIES = [
  "Biology / target validation", "Product / asset", "Translational evidence",
  "Preclinical / safety", "CMC / manufacturing", "Regulatory readiness",
  "IP", "Partnerships / BD", "Team", "Funding",
];
export const TIMEFRAMES = ["Now", "3 months", "6 months", "12 months"];
export const CONFIDENCE = ["High", "Medium", "Low"];

// ---------- EXECUTION GAPS ----------
export const DEFAULT_CAPABILITIES = [
  "Disease biology", "Modality / platform expertise", "Translational pharmacology",
  "Preclinical development", "CMC / manufacturing", "Regulatory strategy",
  "Clinical development", "Biomarker / diagnostics", "IP strategy",
  "BD / pharma partnering", "Fundraising", "Finance / operations",
  "Leadership / CEO credibility", "Board / governance", "Culture / team ways of working",
];
export const COVERED_OPTS = ["Yes", "Partly", "No", "Unknown"];
export const CREDIBILITY_OPTS = ["Strong", "Adequate", "Weak", "Unknown"];
export const GAP_TYPES = ["Hire", "Advisor", "Consultant", "CRO/CDMO partner", "Board member", "Investor network", "Pharma partner", "Not needed yet", "Unknown"];
export const PRIORITY_OPTS = ["Critical before next round", "Important in 6–12 months", "Later", "Unknown"];
export const COMMITMENT_OPTS = ["Full-time founder", "Full-time hire", "Part-time", "Advisor", "Board member", "Consultant"];

export const FIX_TYPES = ["Hire", "Advisor", "Consultant", "CRO/CDMO", "Board member", "Partner", "Delay until later"];
export const TIMING_OPTS = ["Before fundraising", "Within 3 months", "Within 6 months", "Before IND / clinical step", "Before partnership discussion", "Later"];

// ---------- FUNDING FIT ----------
export const ROUND_TYPES = ["Pre-seed", "Seed", "Seed extension", "Series A", "Bridge", "Grant/non-dilutive", "Strategic pharma collaboration", "Disease foundation funding", "Option/licence deal", "Hybrid", "Unsure"];
export const DEFAULT_FUNDING_SOURCES = [
  "Grants / non-dilutive", "Angels", "Seed funds", "Specialist therapeutics VCs",
  "Corporate venture", "Pharma strategic collaboration", "Disease foundation",
  "Patient capital / impact fund", "Licensing / option deal",
  "Service or collaboration revenue", "Existing investors / insiders",
];
export const SOURCE_FIT_OPTS = ["Strong", "Possible", "Weak", "Not relevant", "Unknown"];
export const VALUE_DRIVER_OPTS = [
  { id: "ip",              label: "IP" },
  { id: "lead_asset",      label: "Lead asset" },
  { id: "platform",        label: "Platform" },
  { id: "target_biology",  label: "Target biology" },
  { id: "data",            label: "Data" },
  { id: "team",            label: "Team" },
  { id: "pharma_interest", label: "Pharma interest" },
  { id: "market_space",    label: "Market space" },
  { id: "differentiation", label: "Differentiation" },
  { id: "clinical_evidence", label: "Clinical evidence" },
  { id: "partnerships",    label: "Partnerships" },
  { id: "other",           label: "Other" },
];

// ---------- CAUTIONARY TALES ----------
export const CAUTIONARY_TALES = {
  value_inflection: {
    title: "Activity plan, not milestone plan",
    body: "Many startups present a list of activities: hire CRO, run assay, complete study, file patent, raise money. Investors usually want to know what risk is being removed and what decision changes after each step.",
    lesson: "Convert activities into de-risking milestones with evidence outputs and go/no-go decisions.",
  },
  execution_gaps: {
    title: "Milestone ambition without execution credibility",
    body: "A company may have a scientifically exciting plan, but investors often ask: who has done this before, who owns the difficult parts, and who will make the go/no-go calls?",
    lesson: "Do not only show the team you have. Show the team, advisors and partners required to credibly reach the next milestone.",
  },
  funding_fit: {
    title: "Raising for runway, not value",
    body: "Many startups raise to keep going. Investors usually want to know what the round will prove, what risk it removes, and why the company will be more valuable at the end of the round.",
    lesson: "Design the round around a value-inflection point, not just a budget.",
  },
};

export const SEVERITY_STYLES = {
  high:   "bg-red-50 text-red-800 border-red-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  low:    "bg-slate-50 text-slate-700 border-slate-200",
};
